import repositories from '@/repositories/RepositoryFactory'

export default {
  /**
   * 商品分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 選択モード（商品:item / 分類:category）
       */
      selectMode: 'category',
      /**
       * 選択分類（最下層）一覧
       */
      categories: undefined,
      /**
       * 選択商品一覧
       */
      items: undefined,
      /**
       * 商品グループID
       */
      itemGroupId: undefined,
      /**
       * 分類指定、商品選択での新商品絞り込み
       */
      filterNewItems: false,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(item) {
    if (item.selectMode === 'item') {
      return {
        company: item.company,
        items: item.items ? item.items.map(i => i.code) : undefined,
        itemGroupId: item.itemGroupId,
      }
    } else if (item.selectMode === 'category') {
      return {
        company: item.company,
        categories: item.categories,
        filterNewItems: item.filterNewItems,
      }
    }

    throw new Error(`unknown item select mode: ${item.selectMode}`)
  },
  /**
   * applyToに対してitemを適用する
   */
  applyPayload(applyTo, item) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = item.company
    // 商品（分類から、商品から）選択と分類（階層）選択があるパターン
    if (item.category && item.item) {
      switch (item.selectMode) {
        case 'category':
          applyTo.selectMode = 'category'
          applyTo.filterNewItems = item.category.filterNewItems
          // 階層と分類コードリストの指定では、最下層に変換する
          // 非同期処理なので注意（この処理の終了待機は呼び出し側で行う）
          return repositories
            .get('itemCategory')
            .getDrilldownData(
              item.company,
              item.category.itemCategoryLevel,
              undefined,
              item.category.categories,
            )
            .then(categories => {
              applyTo.categories = categories.map(c => c.code)
            })
        case 'item':
          applyTo.selectMode = 'item'
          applyTo.items = item.item.items
          applyTo.itemGroupId = item.item.itemGroupId
          break
        case 'itemCategory':
          applyTo.selectMode = 'category'
          applyTo.categories = item.item.categories
          applyTo.filterNewItems = item.item.filterNewItems
      }
      return
    }

    applyTo.company = item.company
    applyTo.selectMode = item.selectMode
    applyTo.categories = item.categories
    applyTo.items = item.items
    applyTo.itemGroupId = item.itemGroupId
    applyTo.filterNewItems = item.filterNewItems
  },
}
